import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { ControlGroup } from './ControlGroup';

interface SongConverterSectionProps {
  config: SimulationConfig;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAnalyzing: boolean;
  analysisProgress: number;
}

export const SongConverterSection: React.FC<SongConverterSectionProps> = ({ config, onFileUpload, isAnalyzing, analysisProgress }) => (
  <div className="flex flex-col gap-3 p-4 rounded-3xl border bg-blue-500/5 border-blue-500/20">
    <SectionLabel icon="fa-compact-disc" darkMode={config.darkMode}>MP3 Song Converter</SectionLabel>
    <ControlGroup label="Song Converter" settingKey="songConverter" darkMode={config.darkMode}>
      <label className={`w-full py-3 px-4 rounded-xl border text-[10px] font-black uppercase tracking-widest cursor-pointer flex items-center justify-center gap-2 transition-all ${config.darkMode ? 'bg-neutral-800 border-neutral-700 hover:bg-neutral-700' : 'bg-white border-neutral-200 hover:bg-neutral-50'}`}>
        <i className={`fa-solid ${isAnalyzing ? 'fa-spinner fa-spin' : 'fa-upload'}`}></i>
        {isAnalyzing ? `Analyzing... ${analysisProgress}%` : 'Upload MP3'}
        <input type="file" accept="audio/*" onChange={onFileUpload} className="hidden" />
      </label>
    </ControlGroup>
  </div>
);